import type { SVGProps } from 'react';
const SvgVignettes = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <g clipPath="url(#Vignettes_svg__a)">
      <path
        d="m5.573 3.086-.404.093a1.23 1.23 0 0 1-.943 1.481 1.264 1.264 0 0 1-1.491-.953l-.808.166a.84.84 0 0 0-.632 1.036s.373 1.73.808 3.677m11.238-5.51a1.367 1.367 0 1 1-2.528-1.036l-.839-.394a.92.92 0 0 0-1.201.487l-3.48 8.192-.456 1.036a.92.92 0 0 0 .487 1.202l4.205 1.791a.92.92 0 0 0 1.201-.486l3.936-9.26a.92.92 0 0 0-.445-1.17z"
        strokeLinejoin="round"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </g>
    <defs>
      <clipPath id="Vignettes_svg__a">
        <path d="M0 0h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgVignettes;
